import React from "react";

function cx(...classes) {
  return classes.filter(Boolean).join(" ");
}

/**
 * PageHeader
 * - Title, optional subtitle, optional right-aligned actions area.
 * - Optional breadcrumbs rendered above title when provided.
 */
export function PageHeader({
  title,
  subtitle,
  actions,
  breadcrumbs,
  className = "",
  ...props
}) {
  return (
    <header className={cx("mb-4 md:mb-6", className)} {...props}>
      {breadcrumbs ? <div className="mb-3">{breadcrumbs}</div> : null}
      <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
        <div>
          {title ? (
            <h1
              className="text-2xl font-semibold text-succession-text-primary"
              style={{ margin: 0, padding: 0, border: 'none' }}
            >
              {title}
            </h1>
          ) : null}
          {subtitle ? (
            <p
              className="text-sm text-succession-text-secondary"
              style={{ margin: '0.25rem 0 0 0', padding: 0 }}
            >
              {subtitle}
            </p>
          ) : null}
        </div>
        {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
      </div>
    </header>
  );
}


